import React, { useState } from 'react';
import { api } from '../lib/utils';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Smartphone, User, Lock, LogIn, UserPlus, LayoutGrid } from 'lucide-react';

export default function Login({ onLogin }) {
  const [isRegister, setIsRegister] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    name: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let response;
      if (isRegister) {
        response = await api.post('/auth/register', formData);
        toast.success('Llogaria u krijua me sukses!');
      } else {
        response = await api.post('/auth/login', {
          username: formData.username,
          password: formData.password
        });
      }

      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      onLogin(response.data.user);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gabim në autentikim');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-[#E52B50] rounded-2xl mb-4 shadow-2xl shadow-[#E52B50]/30 transform rotate-3 hover:rotate-0 transition-transform duration-300">
            <LayoutGrid className="w-12 h-12 text-white" />
          </div>
        </div>

        <Card className="border-0 shadow-2xl">
          <CardHeader className="text-center pb-2">
            <CardTitle className="text-xl">
              {isRegister ? 'Krijo Llogari' : 'Kyçu'}
            </CardTitle>
            <CardDescription>
              {isRegister
                ? 'Krijo një llogari të re për të hyrë në sistem'
                : 'Futni kredencialet tuaja për të vazhduar'
              }
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              {isRegister && (
                <div>
                  <Label>Emri i plotë</Label>
                  <div className="relative">
                    <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                    <Input
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      placeholder="Emri Mbiemri"
                      className="pl-10"
                      required
                      data-testid="register-name"
                    />
                  </div>
                </div>
              )}

              <div>
                <Label>Përdoruesi</Label>
                <div className="relative">
                  <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                  <Input
                    value={formData.username}
                    onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                    placeholder="perdoruesi"
                    className="pl-10"
                    required
                    autoComplete="username"
                    data-testid="login-username"
                  />
                </div>
              </div>

              <div>
                <Label>Fjalëkalimi</Label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                  <Input
                    type="password"
                    value={formData.password}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    placeholder="••••••••"
                    className="pl-10"
                    required
                    autoComplete={isRegister ? 'new-password' : 'current-password'}
                    data-testid="login-password"
                  />
                </div>
              </div>

              <Button
                type="submit"
                className="w-full h-11 bg-[#E52B50] hover:bg-[#d02548]"
                disabled={loading}
                data-testid="login-submit"
              >
                {loading ? (
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white" />
                ) : isRegister ? (
                  <>
                    <UserPlus className="w-4 h-4 mr-2" />
                    Regjistrohu
                  </>
                ) : (
                  <>
                    <LogIn className="w-4 h-4 mr-2" />
                    Kyçu
                  </>
                )}
              </Button>
            </form>

            <div className="mt-6 text-center">
              <button
                type="button"
                onClick={() => setIsRegister(!isRegister)}
                className="text-sm text-[#E52B50] hover:underline"
              >
                {isRegister
                  ? 'Ke llogari? Kyçu këtu'
                  : 'Nuk ke llogari? Regjistrohu'
                }
              </button>
            </div>
          </CardContent>
        </Card>

        <p className="text-center text-slate-500 text-sm mt-6">
          © 2026
        </p>
      </div>
    </div>
  );
}
